import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assests/logo.png";
import payhere from "../../assests/payhere.svg";
import counter from "../../assests/counter.svg";
import arrow from "../../assests/arrow.svg";
import { useOrder } from "./OrderContext";
import api, { ApiResponse } from "../../services/api";
import { toast } from "react-hot-toast";
import PaymentPage from "../../components/PaymentPage";
import { MoveLeft } from "lucide-react";

const PayChoice: React.FC = () => {
  const navigate = useNavigate();
  const { orderData, setOrderData } = useOrder();

  const [isOpen, setIsOpen] = useState(false);
  const [amount, setAmount] = useState<number>(orderData ? Number(orderData.totalAmount) : 0);
  // Open the modal when Pay Here is selected
  const handlePayHere = () => {
    console.log("Payment initiated for Pay Here");
    console.log("Amount:", amount);
    setIsOpen(true);
  };
const phoneNumber=orderData?.phoneNumber
  // After successful card payment
  const handleCreateCard = async (_paymentMethod: string, transactionId?: string) => {
    console.log("=== handleCreateCard called ===");
    console.log("Payment method:", _paymentMethod);
    console.log("Transaction ID received:", transactionId);
    console.log("Transaction ID type:", typeof transactionId);
    const orderId = await handlePayChoice("card", transactionId);
        setIsOpen(false);

    if (orderId) {
      console.log("Order placed → navigating");
  setTimeout(() => {
          navigate(`/pos/Confirmation/${orderId}`);
        }, 100);    }
     
  };

const handlePayChoice = async (payChoice: string, transactionId?: string): Promise<string | undefined> => {
    if (!orderData) {
      console.error("No order data available");
      toast.error("Order data is missing");
      return undefined;
    }

    const finalData = { ...orderData, payChoice, ...(transactionId && { transactionId }) };
    setOrderData(finalData);

    console.log("handlePayChoice called with:", { payChoice, transactionId });
    console.log("Final order data being sent:", JSON.stringify(finalData, null, 2));

    try {
      // Place order
      console.log("Placing order with data:", finalData);
      const { data } = await api.post<ApiResponse<any>>("/orders", finalData);

      if (data.success && data.data?._id) {
        console.log("Order created successfully:", data.data._id);
        navigate(`/pos/Confirmation/${data.data._id}`);
        toast.success("Order placed successfully!");
        return data.data._id;
      } else {
        console.error("Order creation failed:", data.error);
        toast.error(data.error || "Failed to place order");
        return undefined;
      }
    } catch (err: any) {
      console.error("Order failed:", err.response?.data || err.message);
      toast.error(err.response?.data?.error || "Failed to place order");
      return undefined;
    }
  };



  const handlePayAtCounter = async () => {
    if (!orderData) {
      toast.error("Order data is missing");
      return;
    }
    try {
      const finalData = { ...orderData, payChoice: "Pay at Counter" };
      const { data } = await api.post<ApiResponse<any>>("/temp-orders", finalData);
      if (data.success && data.data?._id) {
        toast.success("Token generated!");
        navigate(`/pos/token-confirmation/${data.data._id}`);
      } else {
        toast.error("Failed to create temp order");
      }
    } catch (err: any) {
      toast.error(err.response?.data?.error || "Failed to create temp order");
    }
  };

  return (
    <>
      {/* Back Button */}
      <button
        type="button"
        className="absolute top-7 left-12 z-50 h-14 w-14 flex items-center justify-center rounded-full bg-main cursor-pointer transition ease-in-out duration-200 hover:scale-105 hover:shadow-md"
        onClick={() => navigate("/pos")}
      >
        <MoveLeft className="w-1/2 h-auto" color="white" />
      </button>

      {/* Main Content */}
      <div className="w-full max-sm:mt-36 h-screen flex flex-col justify-center items-center relative">

        <h1 className="mb-4  text-3xl sm:text-4xl md:text-5xl lg:text-6xl px-12  font-bold text-black capitalize text-center ">
          Where would you like to pay?
        </h1>

        <div className="two-btn flex flex-col  sm:flex-row items-center justify-center gap-5 sm:gap-6 md:gap-8 lg:gap-10 mt-6 sm:mt-8 md:mt-10 w-full mx-auto max-w-4xl">

          {/* Pay Here Option (Opens Modal) */}
          <div
            className="flex flex-col items-center justify-center w-70 py-5 px-5 text-base font-medium text-center border-2 border-main bg-white rounded-4xl gap-5 cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
            onClick={handlePayHere}
          >
            <img src={payhere} alt="Pay Here" />
            <span className="text-black text-2xl font-semibold">PAY HERE</span>
          </div>

          {/* Counter Option */}
          <div
            className="flex flex-col items-center justify-center w-70 py-5 px-5 text-base font-medium text-center border-2 border-main bg-white rounded-4xl gap-5 cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
            onClick={handlePayAtCounter}
          >
            <img src={counter} alt="Counter" />
            <span className="text-black text-2xl font-semibold">COUNTER</span>
          </div>

        </div>
 {isOpen && (
        <PaymentPage
          pricing={amount}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          handleOrder={handleCreateCard}
          productDescription="Order Payment"
          phone={phoneNumber ?? ""}
        />
 )}
      </div>
    </>
  );
};

export default PayChoice;
